import { TruckIcon } from "@phosphor-icons/react"
import { useTranslation } from "react-i18next"
import { PageLayout } from "../../components/layout"
import { usePermission } from "../../components/permission"
import { PendingDeliveries } from "../../components/pending-deliveries"

export function PendingDeliveriesPage() {
  const { t } = useTranslation(["delivery", "common"])
  const ORD_DN_DRAFT_LIST = usePermission("ORD_DN_DRAFT_LIST")
  const breadcrumbs = useBreadcrumb(t)

  return (
    <PageLayout
      icon={<TruckIcon size={22} />}
      title="Хүлээлтэнд"
      subTitle="Хуваарилах хүлээж байгаа хүргэлт"
      breadcrumb={breadcrumbs}
      noFrame
    >
      {ORD_DN_DRAFT_LIST.hasAccess ? <PendingDeliveries /> : ORD_DN_DRAFT_LIST.accessDenied()}
    </PageLayout>
  )
}

const useBreadcrumb = (t: (key: string) => string) => [
  {
    to: "/",
    label: t("common:breadcrumb.home"),
  },
  {
    label: "Хүлээлтэнд",
  },
]
